import '../styles/about.css'
import { useNavigate } from "react-router-dom";
function About() {
  const navigate = useNavigate();
  return ( 
    <div className = "about-us">
      <div className="about-us-heading">
        <h1>About Us</h1>
        <p> DC Biomedical Services, LLC has provided high-quality maintenance and repair for histology and pathology devices since <span className="about-year">2018</span>. 
          Serving laboratories, hospitals, and research facilities in the Midwest, we help you deliver accurate results with timely equipment maintenance and support. 
          We are a nationally certified MBE company through the NMSDC (National Minority Supplier Development Council).
          </p>
          <button  onClick={() => navigate("/contact-us")}> Contact Us </button>
      </div>
      {/* <div className="about-us-body">
        <h4>Who is DC Biomedical?</h4>
        <p> DC Biomedical Services, LLC is your dependable provider of biomedical equipment maintenance and repair services. 
          For more than 17 years, we have been serving our clients in Illinois and surrounding areas in the Midwest, including Indiana, Iowa, Michigan, and Wisconsin. 
          We provide specialized services to histology and pathology instrumentation in research facilities, independent laboratories and hospitals. 
          We are also certified as a MBE in the state of Illinois as a minority owned business and nationally under the NMSDC. 
          (National Minority Supplier Development Council)
          </p>
      </div> */}
    </div>
  );
}
export default About;
